import { useCallback, useEffect, useMemo, useState } from 'react';
import { theme } from 'antd';
import { useAuth } from "contexts/auth";
import useIsMobile from '@/hooks/useIsMobile';

const useIndex = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [notificationUnreadCount, setNotificationUnreadCount] = useState(0);
  const isMobile = useIsMobile(992);
  const { user, logout } = useAuth();

  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const toggleCollapsed = useCallback(() => {
    setCollapsed((current) => !current);
  }, []);

  const openMenu = useCallback(() => {
    setShowMenu(true);
  }, []);

  const closeMenu = useCallback(() => {
    setShowMenu(false);
  }, []);

  const accountMenuClick = useCallback((e) => {
    if (e.key === "logout") {
      logout();
      return;
    }
  }, [logout]);

  const accountMenu = useMemo(() => ({
    items: [
      {
        key: 'logout',
        label: 'Đăng xuất',
      },
    ],
    onClick: accountMenuClick,
  }), [accountMenuClick]);

  useEffect(() => {
    const onNotificationUnreadUpdated = (event) => {
      const count = Number(event?.detail?.count || 0);
      setNotificationUnreadCount(Number.isFinite(count) && count > 0 ? count : 0);
    };

    window.addEventListener('notification-unread-updated', onNotificationUnreadUpdated);
    return () => {
      window.removeEventListener('notification-unread-updated', onNotificationUnreadUpdated);
    };
  }, []);

  return {
    collapsed,
    toggleCollapsed,
    user,
    colorBgContainer,
    borderRadiusLG,
    accountMenu,
    notificationUnreadCount,
    isMobile,
    showMenu,
    openMenu,
    closeMenu,
  };
};

export default useIndex;
